// Services
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class BackgroundJobService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    fetchJobsInProgress() {
        const url = this.urlsService.BACKGROUND_JOBS.JOBS_IN_PROGRESS;
        return this.ajaxService.getDataObserveBody(url);
    }
}
BackgroundJobService.ɵfac = function BackgroundJobService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BackgroundJobService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
BackgroundJobService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BackgroundJobService, factory: BackgroundJobService.ɵfac, providedIn: 'root' });
